import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient,  HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ErrorsService {

  private API_SEND_ERROR_URL = environment.ipserver + 'AnA-backend/public/support/sendEmailWithError';


  constructor(private http: HttpClient) { }

  public sendEmailError(error: any): Observable<any> {
	let data={
		username:localStorage.getItem('user'),
		password:localStorage.getItem('password'),
		fullname:localStorage.getItem('fullname')
	 }

    const params = new HttpParams({fromObject:data});
    const type = 'text' as 'json';
    return this.http.post(this.API_SEND_ERROR_URL, error, { params, responseType: type });
  }

}
